<script setup>
const route = useRoute()

const computedClass = computed(() => {
  const path = route.path
  const classes = []

  const excludedPaths = [
    '/infanzia/',
    '/primaria/',
    '/istituto',
    '/associazione',
    '/iscrizioni',
  ]

  if (!excludedPaths.some((excludedPath) => path.includes(excludedPath))) {
    classes.push('p-top-xxxl-1')
  }

  return classes
})
</script>

<template>
  <div :class="computedClass">
    <footer class="footer">
      <FooterMenu />
    </footer>
  </div>
</template>

<style lang="scss">
@import './style.scss';
</style>
